module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fa1612f9c0474afcd38008ebc35cf735.png";